module.exports = __webpack_public_path__ + "static/media/Vape-Free-Reverse-Text-Red-X Copy@2x.af8ae56e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vape-Free-Reverse-Text-Red-X Copy@2x.jpg
// module id = 512
// module chunks = 0